import React, { useEffect, useState } from "react";
import { CITIES_DATA } from "../../data/citiesData";
import { useTheme } from "../../contexts/ThemeContext";

// Ícones ----------------------------------------------
const ArrowRightIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.41406 2H25.4141V20" stroke="black" strokeWidth="4" strokeMiterlimit="10" />
    <path d="M25.4141 2L1.41406 26" stroke="black" strokeWidth="4" strokeMiterlimit="10" />
  </svg>
);

// Ícone do WhatsApp
const WhatsAppOutlineIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#000" className="bi bi-whatsapp" viewBox="0 0 16 16">
    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
  </svg>
);

// Ícone de telefone/contato
const ContactOutlineIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#000" className="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
    <path fillRule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
  </svg>
);


// Formatador de telefone
function formatPhone(phone) {
  if (!phone) return "";
  const cleaned = phone.toString().replace(/\D/g, "");
  if (cleaned.length === 11)
    return cleaned.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, "($1) $2$3-$4");
  if (cleaned.length === 10)
    return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  return phone;
}

// COMPONENTE PRINCIPAL ----------------------------------------------
export default function ContactDrawer({ city = "", message = "" }) {
  const { theme } = useTheme();
  const citiesArray = Object.values(CITIES_DATA);

  // Filtra cidades de acordo com o contexto
  const CitiesFilter = citiesArray.filter(c => {

    const ctx = theme?.context?.toLowerCase() || "";

    if (ctx === "") return true;
    if (ctx.includes("respirat")) return c.cpap === true;
    if (ctx.includes("home")) return c.home === true;
    if (ctx.includes("audit")) return c.aud === true;
    return false;
  });

  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedCity, setSelectedCity] = useState(city?.id || "");

  // **Sincroniza selectedCity quando a prop city mudar**
  useEffect(() => {
    if (city?.id) {
      setSelectedCity(city.id);
    }
  }, [city]);

  // Procura a cidade selecionada no array filtrado
  const currentCityData = CitiesFilter.find(c => c.id.toString() === selectedCity.toString()) || null;

  // Só gera o link se houver cidade selecionada
  const whatsappLink = currentCityData
    ? `https://wa.me/${currentCityData.whatsappPhone}?text=${encodeURIComponent(
      message || "Olá! Gostaria de falar com um especialista."
    )}`
    : "#";

  const drawerWidth = "w-80";

  return (
    <div
      className={`fixed top-1/2 right-0 transform -translate-y-1/2 z-50
    ${isExpanded ? "pointer-events-auto" : "pointer-events-none"}`}
    >
      {/* BOTÃO LATERAL */}
      <button
        onClick={() => setIsExpanded(true)}
        className={`fixed top-1/4 right-0 -translate-y-1/2 w-16 bg-black/50 text-white 
          shadow-lg rounded-l-xl flex flex-col items-center justify-center gap-2 py-2
          transition-all duration-300 hover:bg-gray-600
          pointer-events-auto
          ${isExpanded ? "opacity-0" : "opacity-100"}`}
      >
        <div className="w-12 h-12 bg-white rounded-full p-2 flex items-center justify-center">
          <ContactOutlineIcon />
        </div>
        <div className="w-12 h-12 bg-white rounded-full p-2 flex items-center justify-center">
          <WhatsAppOutlineIcon />
        </div>
      </button>

      {/* DRAWER */}
      <div
        className={`bg-white/90 rounded-l-lg shadow-2xl overflow-hidden 
          transition-transform duration-500 ease-in-out ${drawerWidth}
          ${isExpanded ? "translate-x-0" : "translate-x-full"}`}
      >
        {/* FECHAR */}
        <button
          onClick={() => setIsExpanded(false)}
          className="absolute top-3 right-3 p-1 text-gray-500 hover:text-black"
        >
          ✕
        </button>

        {/* CONTEÚDO */}
        <div className="p-6 pt-10 space-y-4 text-center">

          {/* DROPDOWN */}
          {!city && (
            <div className="pb-2">
              <label className="block text-lg font-bold text-gray-800 pb-4">
                Selecione sua cidade
              </label>
              <div
                className={`flex items-center gap-2 px-4 py-2 rounded-lg shadow-md text-white bg-black`}
              >
                <select
                  value={selectedCity}
                  onChange={e => setSelectedCity(e.target.value)}
                  className="w-full p-3 bg-black text-white outline-none focus:outline-none"
                >
                  <option className="text-xl" value="">Escolha...</option>
                  {CitiesFilter.map(c => (
                    <option className="text-xl" key={c.id} value={c.id}>
                      {c.shortName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {/* TELEFONE */}
          {currentCityData && (
            <p className="text-2xl">{formatPhone(currentCityData.phone)}</p>
          )}

          {/* HORÁRIOS */}
          {currentCityData && (
            <div className="space-y-4">
              <p className="text-xl text-gray-900">Horário de atendimento</p>
              <div className="flex justify-center text-center divide-x divide-gray-800">

                {/* Semana */}
                {currentCityData.hoursWeek && (
                  <div className="px-4">
                    <p className="text-xl font-bold text-[#3B7B12] pb-2">Seg - Sex</p>
                    <p className="text-xl">{currentCityData.hoursWeek}</p>
                  </div>
                )}

                {/* Sábado */}
                {currentCityData.hoursweekend && (
                  <div className="px-4">
                    <p className="text-xl font-bold text-[#3B7B12] pb-2">Sáb</p>
                    <p className="text-xl">{currentCityData.hoursweekend}</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* WHATSAPP */}
          <a
            href={whatsappLink}
            target="_blank"
            className={`w-full bg-green-700 hover:bg-green-800 text-white rounded-full p-3 
              flex items-center justify-between shadow-lg transition-colors
              ${!currentCityData && "opacity-40 pointer-events-none"}`}
          >
            <span className="text-xl font-bold ml-4">WhatsApp</span>
            <div className="w-12 h-12 bg-white rounded-full p-2 flex items-center justify-center mr-2">
              <WhatsAppOutlineIcon />
            </div>
          </a>

          {/* TELEFONE */}
          <a
            href={currentCityData ? `tel:${currentCityData.phone}` : "#"}
            style={{ backgroundColor: theme.progressBar }}
            className={`w-full hover:bg-gray-800 text-white rounded-full p-3 
              flex items-center justify-between shadow-lg transition-colors
              ${!currentCityData && "opacity-40 pointer-events-none"}`}
          >
            <span className="text-xl font-bold ml-4">Fale com a gente</span>
            <div className="w-12 h-12 bg-white rounded-full p-2 flex items-center justify-center mr-2">
              <ArrowRightIcon />
            </div>
          </a>

        </div>
      </div>
    </div>
  );
}